import React from "react";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Breadcrumbs";
import usePageMeta from "@/hooks/use-page-meta";
import { GALLERY, BRAND } from "@/constants/content";

export default function GalleryPage() {
  usePageMeta({
    title: "Gallery — KinFlex Home Healthcare in Delhi NCR",
    description: "Real photos from KinFlex Home Healthcare — nurses, elder care, physiotherapy and medical procedures at home.",
    canonical: `https://${BRAND.domain}/gallery`,
  });
  return (
    <Layout>
      <section className="pt-28 pb-6 md:pt-36 md:pb-12 bg-hero-gradient relative overflow-hidden">
        <div className="absolute inset-0 bg-medical-grid opacity-60 pointer-events-none" />
        <div className="container-page relative max-w-4xl">
          <Breadcrumbs items={[{ label: "Gallery" }]} />
          <div className="mt-5 eyebrow">Gallery</div>
          <h1 className="mt-2 font-display font-bold text-slate-900 text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
            Moments of <span className="bg-gradient-to-r from-[#0A84FF] to-[#10B981] bg-clip-text text-transparent">care, captured</span>.
          </h1>
          <p className="mt-6 text-lg text-slate-600 max-w-2xl">
            Real scenes from KinFlex nurses, caretakers and medical staff serving families across Delhi NCR.
          </p>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-white">
        <div className="container-page grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {GALLERY.map((g, i) => (
            <div key={i} className={`group relative overflow-hidden rounded-2xl ring-1 ring-slate-200 ${i === 0 ? "md:col-span-2 md:row-span-2 aspect-square md:aspect-auto" : "aspect-[4/3]"}`} data-testid={`gallery-item-${i}`}>
              <img src={g.src} alt={g.alt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4">
                <div className="text-white text-xs font-medium">{g.alt}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </Layout>
  );
}
